import { z } from "zod";
import { UNIDADES_MEDIDA_INSUMO } from "../enums.js";
export const CrearInsumoSchema = z.object({
    nombre: z.string().min(2, "El nombre debe tener al menos 2 caracteres").max(120),
    unidadMedida: z.enum(UNIDADES_MEDIDA_INSUMO, {
        required_error: "La unidad de medida es requerida",
    }),
    stockActual: z.number().min(0, "El stock inicial no puede ser negativo").default(0),
    stockMinimo: z.number().min(0, "El stock mínimo no puede ser negativo").default(1),
    costoUnitario: z.number().min(0, "El costo unitario no puede ser negativo").default(0),
});
export const EditarInsumoSchema = CrearInsumoSchema.partial();
export const RegistrarEntradaInsumoSchema = z.object({
    cantidad: z.number().positive("La cantidad a ingresar debe ser mayor a 0"),
    costoUnitario: z.number().min(0).optional(),
    motivo: z.string().max(200).optional(),
});
export const ItemRecetaInputSchema = z.object({
    insumoId: z.string().uuid("ID de insumo inválido"),
    cantidadRequerida: z.number().positive("La cantidad requerida debe ser mayor a 0"),
});
export const GuardarRecetaProductoSchema = z.object({
    items: z.array(ItemRecetaInputSchema),
});
// ------------------------------------------------------------------
// Respuestas (lo que el backend REALMENTE devuelve). z.coerce.number()
// en las cantidades por lo mismo de siempre: Prisma serializa `Decimal`
// como string, y algunos endpoints ya lo convierten a mano y otros no
// (ver PROGRESS.md sección 5b/7).
// ------------------------------------------------------------------
const CantidadCoercible = z.coerce.number();
export const MovimientoInsumoItemSchema = z.object({
    id: z.string(),
    sucursalId: z.string(),
    insumoId: z.string(),
    usuarioId: z.string().nullable().optional(),
    tipo: z.string(),
    cantidad: CantidadCoercible,
    stockAnterior: CantidadCoercible,
    nuevoSaldo: CantidadCoercible,
    motivo: z.string().nullable().optional(),
    creadoEn: z.string(),
});
export const InsumoItemSchema = z.object({
    id: z.string(),
    sucursalId: z.string(),
    nombre: z.string(),
    unidadMedida: z.enum(UNIDADES_MEDIDA_INSUMO),
    stockActual: CantidadCoercible,
    stockMinimo: CantidadCoercible,
    costoUnitario: CantidadCoercible,
    activo: z.boolean(),
    esStockBajo: z.boolean().optional(),
    creadoEn: z.string(),
    actualizadoEn: z.string(),
    _count: z.object({ recetaItems: z.number(), movimientos: z.number() }).optional(),
});
export const InsumoDetalleSchema = InsumoItemSchema.extend({
    esStockBajo: z.boolean(),
    movimientos: z.array(MovimientoInsumoItemSchema),
});
export const RecetaItemRespuestaSchema = z.object({
    id: z.string(),
    productoId: z.string(),
    insumoId: z.string(),
    cantidadRequerida: CantidadCoercible,
    insumo: z.object({
        id: z.string(),
        nombre: z.string(),
        unidadMedida: z.enum(UNIDADES_MEDIDA_INSUMO),
        stockActual: CantidadCoercible,
        stockMinimo: CantidadCoercible,
    }),
});
//# sourceMappingURL=insumo.schema.js.map